import React from 'react';
import { Box, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './SideBar';
import { useTheme } from '@emotion/react';
import logo from '../../../assets/smt-logo.webp';

const ManagerLayout = () => {
    const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', bgcolor:theme.palette.secondary.main }}>
      <Sidebar />
      <Box
        sx={{
          flex: 1,
          backgroundColor: theme.palette.common.white,          
          mt: 2,
          mb: 2,
          mr: 2,
          height: '95vh',
          borderRadius:"70px",
          overflow: "hidden"
        }}
      >       
        <Box display="flex" justifyContent="center" pt={1}>
          <Box component="img" onClick={() => (window.location.href = '/')} src={logo} width={228} height={68} sx={{cursor:"pointer"}}/>      
        </Box>
        <Outlet />
      </Box>
    </Box>
  );
};

export default ManagerLayout;
